// import logo from './logo.svg';

import { Routes, Route } from 'react-router-dom'
import './App.css';
import Home from './pages/Home';
import About from './pages/About';
import Teams from './pages/Teams';
import Location from './pages/Loacation';
import DebtFunding from './pages/DebtFunding';
import EquityRaising from './pages/EquityRaising'
import HybridFinance from './pages/HybridFinance';
import InternationalFunding from './pages/InternationalFunding'
import Privacypolicy from './pages/Privacypolicy';
import TermandCondition from './pages/TermandCondition';
import StructuredFinance from './pages/StructuredFinance';
import ContactUS from './pages/ContactUs';


function App() {

  return (
    <>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/leadership" element={<Teams/>}></Route>
        <Route path="/location" element={<Location/>}></Route> 
        <Route path="/expertises/debt-funding" element={<DebtFunding/>}></Route>
        <Route path="/expertises/equity-raising" element={<EquityRaising/>}></Route> 
        <Route path="/expertises/hybrid-finance" element={<HybridFinance/>}></Route>
        <Route path="/expertises/structured-finance" element={<StructuredFinance/>}></Route> 
        <Route path="/expertises/international-funding" element={<InternationalFunding/>}></Route>
        <Route path='/contact-us' element={<ContactUS/>}></Route>
        <Route path='/privacy-policy' element={<Privacypolicy />}></Route>
        <Route path='/terms-and-conditions' element={<TermandCondition />}></Route>

      </Routes>


    </>

  );
}

export default App;